<script setup lang="ts">
import PdsToast from '@/components/pds/PdsToast.vue';
import PdsToastButton from '@/components/pds/PdsToastButton.vue';
import { usePdsOrdersStore } from '../stores/orders.store';

const store = usePdsOrdersStore();
</script>

<template>
  <PdsToast v-if="store.actionError" title="Action non enregistrée">
    {{ store.actionError }}
    <template #aside>
      <PdsToastButton @click="store.dismissActionError()"
        >Fermer</PdsToastButton
      >
    </template>
  </PdsToast>
</template>
